import React, { PureComponent } from "react";
import axios from "axios";
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Input,
  Label,
  Button,
  Table
} from "reactstrap";
import LoaderSpinner from "../Widgets/LoaderSpinner";
import authProtection from "../../HOCs/authProtection";
import withAlertTimeout from "../../HOCs/withAlertTimeout";
import Alert from "../Widgets/Alert";
import isEmail from 'validator/lib/isEmail'
import LinkBusinessToOwner from '../Components/LinkBusinessToOwner'
import qs from "query-string";

class CreateUser extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      fullName: "",
      username: "",
      emailID: "",
      password: "",
      errorMessage: "Something went wrong, please try again",
      successMessage: 'Successful',
      isSubmitting: false,
      showModal: false,
      businessName: '',
      businessCity: '',
      newBusinessName: '',
      newBusinessLocation: {},
      newBusinessContact: '',
      isSearching: false,
      userID: null,
      searchResults: '',
      addBusinessClicked: false
    };

    this.onQueryInput = this.onQueryInput.bind(this);
    this.onCreateUser = this.onCreateUser.bind(this);
    this.generatePassword = this.generatePassword.bind(this);
    this.updateBusinessInfo = this.updateBusinessInfo.bind(this);
    this.updateAddNewBusinessInfo = this.updateAddNewBusinessInfo.bind(this);
    this.onSearchBusiness = this.onSearchBusiness.bind(this);
    this.onSelectBusiness = this.onSelectBusiness.bind(this);
    this.onModalButtonClicked = this.onModalButtonClicked.bind(this);
    this.addBusiness = this.addBusiness.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.isSuperAdmin = false;
  }

  componentDidMount() {
    document.querySelector("#full-name-input").focus();

    const user = JSON.parse(sessionStorage.getItem("user"));
    if (
      user.privyData.group.goNation.some(item => item.name === "SuperAdmin")
    ) {
      this.isSuperAdmin = true;
    }

    this.generatePassword();
    
  }

  onQueryInput(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  generatePassword() {
    let chars = "abcdefghijklmnopqrstuvwxyz!@#$%^&*()-+<>ABCDEFGHIJKLMNOP1234567890";
    let pass = "";
    for (let x = 0; x < 10; x++) {
        let i = Math.floor(Math.random() * chars.length);
        pass += chars.charAt(i);
    }

    this.setState({password: pass})
  }

  onCreateUser() {

    if(this.state.fullName === '')
    {
      this.setState(
        {errorMessage: 'Please enter a valid name.'},
        this.props.showFailure
    );
    return
    }

    if(this.state.username === '')
    {
      this.setState(
        {errorMessage: 'Please enter a valid username.'},
        this.props.showFailure
    );
    return
    }

    if(!isEmail(this.state.emailID)) {
      this.setState(
          {errorMessage: 'Please enter a valid email ID.'},
          this.props.showFailure
      );
      return
    }

    this.setState({ isSubmitting: true });

    const userObject = {
      provider: 'Gonation',
      username: this.state.username,
      email: this.state.emailID.toLowerCase(),
      password: this.state.password,
      tncAcceptance: true,
      fullname: this.state.fullName
    }

    axios
    .post(
      `api/proxy/v2/users`, userObject
    )
    .then((res) => {
      this.setState(
          {successMessage: 'User created successfully. Email confirmation link sent.'},
          this.props.showSuccess
      )
      this.setState({userID: res.data.id}, () => {setTimeout(() => { this.sendForgotPasswordEmail(); }, 3000);})
    })
    .catch((error)=> {
        this.setState(
            {errorMessage: error.response.data.error, isSubmitting: false},
            this.props.showFailure
        );
    })
    
  }

  onModalButtonClicked() {
    this.setState({addBusinessClicked: true})
  }

  addBusiness() {
    console.log(this.state.newBusinessName, this.state.newBusinessContact, this.state.newBusinessLocation)
    const params = {
      "name": this.state.newBusinessName,
      "contact": {phone: this.state.newBusinessContact},
      "location": this.state.newBusinessLocation,
      "categories": []
    }
    const token = sessionStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };
    axios
    .post(`/api/proxy/v2/businesses`, params, { headers })
    .then((res) => {
      console.log("resss",res)
      this.setState(
        {successMessage: 'Business created successfully.'},
        this.props.showSuccess
      ,)
      setTimeout(() => { this.onSelectBusiness(res.data.id); }, 1000);
    })
    .catch((error)=> {
        this.setState(
            {errorMessage: error.response.data.error},
            this.props.showFailure
        );
    })
    .finally(() => {
      this.setState({ showModal: false, isSubmitting: false, addBusinessClicked: false, businessName: "", businessCity: "", newBusinessName: "", newBusinessLocation: {}, newBusinessContact: ""});
    });
  }

  sendForgotPasswordEmail() {
    const params = {
      "email": this.state.emailID.toLowerCase()
    };
    const token = sessionStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };
    axios
    .post(
      `api/proxy/v2/password/email`,
      params,
      { headers }
    )
    .then((res) => {
      this.setState(
        {successMessage: 'Password reset email sent.', isSubmitting: false},
        this.props.showSuccess
      )
      setTimeout(() => { this.setState({showModal: true}); }, 1000);
    })
    .catch((error)=> {
        this.setState(
            {errorMessage: error.response.data.error, isSubmitting: false, showModal: false},
            this.props.showFailure
        );
    })
    
  }

  updateBusinessInfo(name, city) {
    this.setState({businessName: name, businessCity: city})
  };

  updateAddNewBusinessInfo(name, location, contact) {
    this.setState({newBusinessName: name, newBusinessLocation: location, newBusinessContact: contact})
  }

  onSelectBusiness(businessID) {
    const params = {
      "name": "BusinessOwner",
      "entityId": businessID
    };
    const token = sessionStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };
    axios
    .put(
      `api/proxy/v2/users/${this.state.userID}/permisgroups/invite`,
      params,
      { headers }
    )
    .then((res) => {
      this.setState(
        {successMessage: 'Business Owner invitation email sent successfully.'},
        this.props.showSuccess
      )
    })
    .catch((error)=> {
        this.setState(
            {errorMessage: error.response.data.error},
            this.props.showFailure
        );
    })
    .finally(() => {
      this.setState({ showModal: false, addBusinessClicked: false, businessName: "", businessCity: "", newBusinessName: "", newBusinessLocation: null, newBusinessContact: ""});
    });
  }

  onSearchBusiness() {
    this.setState({isSearching: true});
    const token = sessionStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };
    const query = {};

    if (this.state.businessName) {
      query.name = this.state.businessName;
    }

    if (this.state.businessCity) {
      query.geofence = this.state.businessCity;
    }

    axios
      .get(`/api/proxy/v2/businesses?${qs.stringify(query)}`, headers)
      .then(({ data }) => {
        this.setState({searchResults: data.items})
      })
      .catch((error)=> {
        this.setState(
            {errorMessage: error.response.data.error, isSubmitting: false},
            this.props.showFailure
        );
      })
      .finally(() => {
        this.setState({ isSearching: false});
      });
  }

  closeModal() {
    this.setState({ showModal: false, addBusinessClicked: false, searchResults: ''});
  }

  render() {


    return [
      <LinkBusinessToOwner
        key="LinkBusinessToOwnerModal"
        open={this.state.showModal}
        onClose={this.closeModal}
        onChange={this.updateBusinessInfo}
        onChangeAddBusiness = {this.updateAddNewBusinessInfo}
        onSearchBusiness={this.onSearchBusiness}
        onSelectBusiness={this.onSelectBusiness}
        addBusiness={this.addBusiness}
        searchResults={this.state.searchResults}
        buttonsDisabled={this.state.isSearching}
        inputBusinessName={this.state.businessName}
        inputBusinessCity={this.state.businessCity}
        addBusinessClicked={this.state.addBusinessClicked}
        onModalButtonClicked={this.onModalButtonClicked}
      />,
      <Row>
        <Col xs='12'>
          <Card>
            <CardHeader>Create User</CardHeader>
            <CardBody>
              {
                <Alert
                  active={this.props.success}
                  message={this.state.successMessage}
                />
              }
              {
                <Alert
                  type='danger'
                  active={this.props.failure}
                  message={this.state.errorMessage}
                />
              }
              <FormGroup>
                <Label htmlFor='full name'>Full Name</Label>
                  <Input
                    type='text'
                    name='fullName'
                    id='full-name-input'
                    placeholder='Enter Full Name'
                    value={this.state.fullName}
                    onChange={this.onQueryInput}
                  />
              </FormGroup>

              <FormGroup>
                <Label htmlFor='username'>Username</Label>
                <Input
                  type='text'
                  name='username'
                  placeholder='Enter Username'
                  value={this.state.username}
                  onChange={this.onQueryInput}
                />
              </FormGroup>

              <FormGroup>
                <Label htmlFor='email ID'>Email ID</Label>
                <Input
                  type='email'
                  name='emailID'
                  placeholder='Enter Email ID'
                  value={this.state.emailID}
                  onChange={this.onQueryInput}
                />
              </FormGroup>

              <FormGroup>
                <Label htmlFor='password'>
                  Default Password
                  <i onClick={this.generatePassword} class="fa fa-refresh" style={{marginLeft: '10px', color: '#20BED6', cursor: 'pointer'}}></i>  
                </Label>
                <Input
                  type='text'
                  name='password'
                  value={this.state.password}
                  disabled={true}
                />
              </FormGroup>

              <div className='form-actions'>
                <Button
                  onClick={this.onCreateUser}
                  type='submit'
                  color='primary'
                  disabled={this.state.isSubmitting}>
                  Submit
                </Button>
              </div>
            </CardBody>
          </Card>
          {this.state.isSubmitting && <LoaderSpinner />}
        </Col>
      </Row>,
      
    ]
  }
}

export default authProtection(withAlertTimeout(CreateUser));


// WEBPACK FOOTER //
// ./src/views/Pages/CreateUser.js